import { Table, Container, Row, Col } from "react-bootstrap";
import Styles from "./index.module.css";
import { useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import cx from "classnames";

const Status = ({ text, type }) => {
  return <span className={cx(Styles.status, Styles[type])}>{text}</span>;
};

const SubmissionsTable = () => {
  const { params } = useRouteMatch();
  const { problemUrl } = params;

  const logs = useSelector((state) => state.log[problemUrl] || []);
  const logsMapped = logs.map(({ dateTime, result }) => {
    const { status } = result;
    return (
      <tr key={dateTime}>
        <td>{dateTime}</td>
        <td>
          <Status text={status} type={status} />
        </td>
      </tr>
    );
  });
  return (
    <Table striped bordered>
      <thead>
        <tr>
          <th>Last Submitted</th>
          <th>Solution</th>
        </tr>
      </thead>
      <tbody>{logsMapped}</tbody>
    </Table>
  );
};

const Failedetails = ({ details }) => {
  const { input, output, expected } = details;
  const InputString = JSON.stringify(input, function (key, val) {
    return typeof val === "function" ? "" + val : val;
  });
  return (
    <Container>
      <Row className="align-items-center">
        <Col xs={3}>Input</Col>
        <Col xs={9}>
          <pre>{InputString}</pre>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col xs={3}>Output</Col>
        <Col xs={9}>
          <pre>{`${JSON.stringify(output)}`}</pre>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col xs={3}>Expected</Col>
        <Col xs={9}>
          <pre>{`${JSON.stringify(expected)}`}</pre>
        </Col>
      </Row>
    </Container>
  );
};

const Erroretails = ({ details }) => {
  const { message } = details;
  return (
    <Container>
      <Row className="align-items-center">
        <Col>Error</Col>
        <Col>
          <pre className={Styles.failed}>{JSON.stringify(message)}</pre>
        </Col>
      </Row>
    </Container>
  );
};

const Submissions = () => {
  const { params } = useRouteMatch();
  const { problemUrl } = params;

  const logs = useSelector((state) => state.log[problemUrl] || []);

  const Error = () => {
    if (logs.length) {
      const { result } = logs[0];
      const { status, details } = result;
      if (status === "failed") {
        return (
          <>
            <Failedetails details={details} /> <hr />
          </>
        );
      } else if (status === "error") {
        return (
          <>
            <Erroretails details={details} /> <hr />
          </>
        );
      } else {
        return null;
      }
    }

    return null;
  };

  return (
    <>
      <Error />
      <SubmissionsTable />
    </>
  );
};

export default Submissions;
